import Switch from '@components/v2/form/Switch/Switch';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';
import { OrderProductsViewSwitchConfig } from '../orderProductsViewButton.types';

const ROW_HEIGHT = 22;

interface OrderProductsViewSwitchRowProps {
  label: LangEnum;
  testId: string;
  config: OrderProductsViewSwitchConfig;
}

const OrderProductsViewSwitchRow = ({ label, testId, config }: OrderProductsViewSwitchRowProps) => {
  const { translate } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{ height: ROW_HEIGHT, gap: 1, alignItems: 'center', justifyContent: 'space-between' }}
    >
      <Typography variant="body2" color="text.secondary" noWrap>
        {translate(label)}
      </Typography>

      <Switch
        size="medium"
        checked={config.isChecked}
        testId={testId}
        slotProps={{ input: { 'aria-label': translate(label) } }}
        onChange={(_, isChecked) => config.onChange(isChecked)}
      />
    </Stack>
  );
};

export default OrderProductsViewSwitchRow;
